import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { RefreshTokenModel } from 'src/app/_models/Authentication/refresh-token.model';
import { ApiService } from 'src/app/_services/api.service';
import { AuthService } from 'src/app/_services/auth.service';
import { TokenStorageService } from 'src/app/_services/token-storage.service';
import { RoleTypeEnum } from 'src/app/admin-panel/enums/role-type.enum';

@Component({
  selector: 'app-login-with-refresh-token',
  templateUrl: './login-with-refresh-token.component.html',
  styleUrls: ['./login-with-refresh-token.component.scss']
})
export class LoginWithRefreshTokenComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  // public loginModel: LoginModel = new LoginModel();
  //#endregion

  //#region Constructor
  constructor(
    public _router: Router,
    public authenticationService: AuthService,
    public apiService: ApiService,
    private tokenStorage: TokenStorageService,
    public messageService: MessageService,
    private _jwtHelperService: JwtHelperService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(async params => {
      // localStorage.removeItem('auth-token');
      // localStorage.removeItem('userData');
      if (params['refresh-token'].length >= 86) {
        const refreshToken = new RefreshTokenModel();
        refreshToken.token = params['refresh-token'] + "==";
        this.apiService.refreshToken(refreshToken)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe({
            next: (response) => {
              const decodedToken = this._jwtHelperService.decodeToken(response.jwtToken);
              const ustp = decodedToken.ustp.split(',').map((x: string) => +x);
              const rlnm = decodedToken.rlnm.split(',').map((x: string) => +x);
              // const loggedInUser = new UserModel(decodedToken.id, decodedToken.rlnm.split(',').map((x: string) => +x));
              if (ustp.includes(RoleTypeEnum.Advertiser)) {
                this.tokenStorage.saveToken(response.jwtToken);
                this.tokenStorage.saveRefreshToken(response.refreshToken);
                this.authenticationService._isSuperAdmin$.next(false);
                this.authenticationService._isTechSupport$.next(false);
                this.authenticationService._isAdvertiser$.next(true);
                this.authenticationService._isLoggedIn$.next(true);
                this.authenticationService.handleAuthentication();
                this._router.navigate(['/promoter/venues']);
              } else {
                this._router.navigateByUrl('login');
              }
            },
            error: (error) => {
              this._router.navigateByUrl('login');
            }
          })
      } else {
        this._router.navigateByUrl('login');
      }
    });
  }
  //#endregion

  //#region Public Methods
  //#endregion

}
